module.exports = __webpack_public_path__ + "img/2.8d394708.png";